export default class CanvasRenderer {
  constructor(canvas) {
    this.canvas = canvas;
    this.doScaleToPixelRatio = true;
    this.canvasSize = null;
    this.imgSize = null;
    this.transform = false;
    this.isFlipped = false;
    this.isFlipped90 = false;
    this.isFlipped270 = false;
    this.flippedX = false;
    this.isDeepDeeAnnotation = false;
    this.forceTranslate = false;
    this.toSave = false;
    this.name = "";
  }

  clear() {
    this.prepareCanvas();
  }

  drawImg(img) {
    if (!this.imgSize || !this.canvasSize) return;
    if (img) this.renderImg(img, this.prepareCanvas());
  }

  drawImgBounded(img, bounds) {
    if (!this.imgSize || !this.canvasSize) return;
    if (img && bounds) this.renderImgBounded(img, bounds, this.prepareCanvas());
  }

  renderImg(img, ctx) {
    if (img && this.isFlipped90 || this.isFlipped270) {
      ctx.drawImage(img, -this.canvas.height/2, -this.canvas.width/2, this.canvas.height, this.canvas.width);
      ctx.restore();
    }
    else if (img && this.isDeepDeeAnnotation)
      ctx.drawImage(img, 200, 625, this.imgSize.w - 500, this.imgSize.h - 500);
    else {
      ctx.drawImage(img, 0, 0, this.imgSize.w, this.imgSize.h);
    }
  }

  renderImgBounded(img, bounds, ctx){
    if (!img || !bounds || !this.canvasSize) return;
    const w = this.canvasSize.w;
    const h = this.canvasSize.h;
    const { minX, maxX, minY, maxY } = bounds;
    ctx.drawImage(img, minX * w, minY * h, (maxX - minX) * w, (maxY - minY) * h);
  }

  drawAnnotation(annotation) {
    if (!this.canvasSize) return;
    if (annotation && annotation.hasOwnProperty("isFlipped270") && annotation.isFlipped270 != this.isFlipped270)
      annotation.isFlipped270 = this.isFlipped270;
    if (annotation) 
      this.renderAnnotation(annotation, this.prepareCanvas());
  }

  renderAnnotation(annotation, ctx) {
    ctx.save();
    annotation.draw(ctx);
    ctx.restore();
  }

  prepareCanvas() {
    const ctx = this.canvas.getContext("2d");
    this.cleanupCanvas(ctx);

    if (this.doScaleToPixelRatio) this.scaleToDevicePixelRatio(ctx);

    if (this.transform) this.transformCanvas(ctx);
    if (this.isFlipped) this.flipCanvas(ctx);
    if (this.isFlipped90) this.rotateCanvas(ctx, 90 * Math.PI / 180);
    if (this.isFlipped270) this.rotateCanvas(ctx, 270 * Math.PI / 180);
    if (this.flippedX) this.flipCanvasX(ctx);
    
    return ctx;
  }

  scaleToDevicePixelRatio(ctx) {
    let scale = window.devicePixelRatio || 1;
    let w = this.canvasSize.w;
    let h = this.canvasSize.h;
    this.canvas.style.width = w + "px";
    this.canvas.style.height = h + "px";
    if (this.isFlipped270 || this.forceTranslate) this.canvas.style.transform = "translate(-60%, -50%)"
    this.canvas.width = w * scale;
    this.canvas.height = h * scale;
    ctx.scale(scale, scale);
  }

  cleanupCanvas(ctx) {
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }

  transformCanvas(ctx) {
    if (this.isFlipped270)
      ctx.translate(this.transform.offsetY, this.transform.offsetX);
    else
      ctx.translate(this.transform.offsetX, this.transform.offsetY);
    ctx.scale(this.transform.zoom, this.transform.zoom);
  }

  flipCanvas(ctx){
    ctx.scale(-1, -1);
    ctx.translate(-this.imgSize.w, -this.imgSize.h);
  }

  flipCanvasX(ctx) {
    ctx.scale(-1, 1);
    ctx.translate(-this.imgSize.w, 0);
  }

  rotateCanvas(ctx, angle) {
    ctx.save();
    if (!this.toSave)
      ctx.translate(this.imgSize.w/2, this.imgSize.h/2);
    else
      ctx.translate(this.imgSize.h/2, this.imgSize.w/2);
    ctx.rotate(angle);

    // Adjustments for zoom control
    if (this.name != "imageZoom" && !this.toSave)
      ctx.translate(-this.imgSize.w/2, -this.imgSize.h/2);

    if (this.name != "imageZoom" && !this.toSave && this.isFlipped270) {
      let diff = this.canvasSize.h - this.canvasSize.w;
      ctx.translate(-diff / 2, -diff / 2);
    }

    // Resize canvas to accomodate for new image ratio
    if (this.name == "imageZoom") {
      let w = this.imgSize.w;
      let h = this.imgSize.h;
      if (w > this.canvas.clientHeight) {
        this.canvas.style.width = h * (this.canvas.clientHeight/this.canvas.clientWidth) + "px";
        this.canvas.style.height = this.canvas.clientHeight + "px";
      }
      else if (h > this.canvas.clientWidth) {
        this.canvas.style.height = w * (this.canvas.clientWidth/this.canvas.clientHeight) + "px";
        this.canvas.style.width = this.canvas.clientWidth + "px";
      }
      else {
        this.canvas.style.width = h + "px";
        this.canvas.style.height = w + "px";
      }
    }
  }
}